export default __webpack_public_path__ + "static/media/learose5-1440w.2c4c6fd1.webp";